<main class="main-container">

    <!-- هدر صفحه -->

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">
      
          <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
      
          <span class="my-auto f16 fw-bold me-2"> تعرفه&zwnj;ها  </span>
      
        </div>
      
    </div>

    <!-- تب ها -->

    <ul class="nav nav-tabs text-center dirI m-4 mx-3 position-sticky top-0 bg-white" style="z-index: 4;">

        <!-- استانها و ضریب -->

        <li class="nav-item">

          <a class="nav-link" [ngClass]="tabView == 1 ? 'active' : '' " (click)="setActiveTab(1)">
            
                استان&zwnj;ها و ضریب 
        
          </a>

        </li>

        <!-- تعرفه های گروه خودرویی  -->

        <li class="nav-item">

            <a class="nav-link" [ngClass]="tabView == 2 ? 'active' : '' " (click)="setActiveTab(2)">
                
                گروه خودرویی 
            
            </a>

        </li>


    </ul>

    <!-- استانها و ضریب -->

    <ng-container *ngIf="tabView == 1">

        <section class="p-2">

            <div class="border border-2 p-2">

                <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($event.target.value)">
        
                <div class="section border border-2 mt-2" style="height:calc(100vh - 190px);overflow: auto;">
        
                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                        <thead>
        
                            <tr class=" text-center">
        
                                <th class="text-center col-1"> # </th>
        
                                <th class="text-center"> عملیات </th>

                                <th class="text-center"> استان </th>
        
                                <th class="text-center"> ضریب تعرفه </th>
        
                            </tr>
        
                        </thead>
        
                        <tbody>
        
                            <tr class="col-12 text-center" *ngFor="let item of lst_State;let i = index">
        
                                <td>{{ i + 1 | faNum }}</td>

                                <td class="">

                                    <i [ngClass]="item?.isEdit ? 'fa-check text-success' : 'fa-pencil-square' " 

                                        (click)="item?.isEdit ? submit_State() : editState(false,item,i)"
                                    
                                        class="fa fa-lg pointer"></i>

                                    <i *ngIf="item?.isEdit" class="fa fa-close fa-lg mx-2 text-danger pointer" (click)="editState(true)"></i>

                                </td>

                                <td> {{ item.strStateName }} </td>

                                <td *ngIf="!item?.isEdit"> {{ item.fTariffFactor | faNum }} </td>

                                <td class="d-flex justify-content-center" [formGroup]="mdl_State" *ngIf="item?.isEdit"> 

                                    <input type="text" 

                                        oninput="this.value = this.value.replace(/[^0-9.]/g,'')  

                                        .replace(/(\..*?)\..*/g, '$1') 

                                        .replace(/(\.\d{2})\d+/g, '$1')"

                                        class="form-control text-center fa-check w-50" 
                                        
                                        formControlName="fTariffFactor">
                                    
                                </td>
            
                            </tr>
        
                        </tbody>
        
                    </table>
        
                </div>
        
            </div>

        </section>


    </ng-container>

    <!-- تعرفه‌های گروه خودرویی -->

    <ng-container *ngIf="tabView == 2">

        <section class="p-2">

            <div [formGroup]="mdl_MobileGroup" class="row justify-content-center gx-0 gx-md-2 gy-2 gy-md-0 p-2">

                <div class="col-12 mt-3 row gx-0 gx-md-2 gy-2 gy-md-3 p-2 pt-3">

                    <!-- حوزه خدمت -->
        
                    <div class="col-12 position-relative">
        
                        <label class="mb-2 text-muted"> حوزه خدمت </label>
            
                        <select class="form-select p-2" formControlName="iMobileDomain" (change)="mdl_MobileGroup.get('tiMobileGroup')?.value != '' ? searchBy_Group() : ''">
            
                            <option class="text-center" value=""> انتخاب کنید </option>
            
                            <option class="text-center" *ngFor="let item of lst_MobileDomain" [value]="item.iMobileDomain">

                                {{item.strComment}}
            
                            </option>
            
                        </select>
            
                    </div>

                    <!-- گروه خودرویی -->
        
                    <div class="col-12 position-relative">
        
                        <label class="mb-2 text-muted"> گروه خودرویی </label>
            
                        <select class="form-select p-2" formControlName="tiMobileGroup" (change)="searchBy_Group()">
            
                            <option class="text-center" value=""> انتخاب کنید </option>
            
                            <option class="text-center" *ngFor="let item of lst_GroupCar" [value]="item.tiMobileGroup">

                                {{item.strComment}}
            
                            </option>
            
                        </select>
            
                    </div>

                    <!-- ورودی -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> ورودی </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                        
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iInputAmount">
            
                    </div>

                    <!-- هر کیلومتر -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> هر کیلومتر(ریال) </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                        
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iPerKm">
            
                    </div>

                    <!-- هر ساعت توقف -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> هر ساعت توقف(ریال) </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                        
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iStoppageFee">
            
                    </div>

                    <!-- ورود به طرح اصلی(ریال) -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> ورود به طرح اصلی(ریال) </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                        
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iTraffic">
            
                    </div>

                    <!-- ورود به طرح آلودگی (ریال)  -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> ورود به طرح آلودگی (ریال) </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                        
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iEvenOdd">
            
                    </div>

                    <!-- هزینه آماده سازی (ریال)  -->

                    <div *ngIf="bEmdadRan" class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> هزینه آماده سازی (ریال) </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                        
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iPreparation">
            
                    </div>

                    <!-- درصد منطقه کوهستانی  -->

                    <div *ngIf="bEmdadRan" class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد منطقه کوهستانی </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiMountainousPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiMountainousPercentage')?.hasError('max')">

                          <span class="text-danger">

                            درصد منطقه کوهستانی نمی تواند بیشتر از 200 باشد

                          </span>

                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiMountainousPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                              درصد منطقه کوهستانی نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>
                    
                    <!-- درصد شرایط آب و هوا  -->

                    <div *ngIf="bEmdadRan" class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد شرایط آب و هوا </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiBadWetherPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiBadWetherPercentage')?.hasError('max')">

                          <span class="text-danger">

                            درصد شرایط آب و هوا نمی تواند بیشتر از 200 باشد

                          </span>

                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiBadWetherPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                              درصد شرایط آب و هوا نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>
                    
                    <!-- درصد شبانه  -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد شبانه </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiNightlyPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiNightlyPercentage')?.hasError('max')">

                          <span class="text-danger">

                            درصد شبانه نمی تواند بیشتر از 200 باشد

                          </span>

                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiNightlyPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                              درصد شبانه نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>
                    
                    <!-- درصد تخفیف  -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد تخفیف </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiDiscountPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiDiscountPercentage')?.hasError('max')">

                          <span class="text-danger">

                            درصد تخفیف نمی تواند بیشتر از 200 باشد

                          </span>

                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiDiscountPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                              درصد تخفیف نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>

                    <!-- درصد برگشت -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد برگشت </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiComeBackPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiComeBackPercentage')?.hasError('max')">

                          <span class="text-danger">

                            درصد برگشت نمی تواند بیشتر از 200 باشد

                          </span>

                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiComeBackPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                              درصد برگشت نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>

                    <!-- درصد روزهای خاص -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد روزهای خاص </label>
            
                        <input class="form-control p-2 text-center" formControlName="iSpatialDayPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('iSpatialDayPercentage')?.hasError('max')">

                            <span class="text-danger">
  
                                درصد روزهای خاص نمی تواند بیشتر از 200 باشد
  
                            </span>
  
                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('iSpatialDayPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                                درصد روزهای خاص نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>

                    <!-- درصد کمیسیون -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد کمیسیون </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiCommissionPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiCommissionPercentage')?.hasError('max')">

                            <span class="text-danger">
  
                                درصد کمیسیون نمی تواند بیشتر از 200 باشد
  
                            </span>
  
                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiCommissionPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                                درصد کمیسیون نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>

                    <!-- درصد پیش پرداخت -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> درصد پیش پرداخت </label>
            
                        <input class="form-control p-2 text-center" formControlName="tiAdvancePaymentPercentage">

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiAdvancePaymentPercentage')?.hasError('max')">

                            <span class="text-danger">
  
                                درصد پیش پرداخت نمی تواند بیشتر از 200 باشد
  
                            </span>
  
                        </div>

                        <div class="pt-1" *ngIf="mdl_MobileGroup.get('tiAdvancePaymentPercentage')?.hasError('min')">

                            <span class="text-danger">
  
                                درصد پیش پرداخت نمی تواند کمتر از 0 باشد
  
                            </span>
  
                        </div>
            
                    </div>

                    <!-- ذخیره -->

                    <div class="position-relative col-12">

                        <button class="btn btn-success w-100" (click)="submit_Tariff()"> 

                            ذخیره تعرفه
                            
                        </button>

                    </div>

                </div>
    
            </div>

        </section>

    </ng-container>

</main>